import { jsx as i } from "react/jsx-runtime";
import { attributes as c } from "../utils/attributes.js";
import '../../assets/Backdrop.css';function p({ open: r, onClose: t, className: o = "" }) {
  const a = c({ "aria-expanded": r });
  return /* @__PURE__ */ i("div", { ...a, className: "backdrop " + o, onClick: t });
}
export {
  p as Backdrop
};
//# sourceMappingURL=Backdrop.js.map
